import {Device, DeviceInfo} from '@capacitor/core'
import {usePromise} from '../promise'

export const useDeviceInfo = () => {
  return usePromise<DeviceInfo>(() => Device.getInfo(), {
    immediate: true,
  })
}
